import React from 'react'

//components
import Button from '../../global/button'
import Modal from '../../global/modal'

//style
import * as styled from '././partnersModalStyle'

type NotificationModalProps = {
  onClose: () => void
  open: boolean
  data: any
}

const PartnersModal = (props: NotificationModalProps) => {
  var partnerData = props.data

  if (partnerData === undefined) return null
  let title, desc, linkHref
  if (partnerData) {
    if (partnerData['Partner_Locator_Account_Name__c']) {
      title = partnerData['Partner_Locator_Account_Name__c']
    }
    if (partnerData['Partner_Locator_Account_Description__c']) {
      desc = partnerData['Partner_Locator_Account_Description__c']
    }
    if (partnerData['Partner_Locator_Website__c']) {
      linkHref = partnerData['Partner_Locator_Website__c']
    }
  }

  const handleClose = () => {
    props.onClose()
  }

  return (
    <Modal
      modalTitle={'Standard Modal'}
      modalDescription={'UiPath Partner Modal'}
      handleClose={handleClose}
      open={props.open}>
      <div className="Modal-Fields-Container">
        <styled.PartnerModalWrapper>
          <h3 className="Partner-Modal__Title">{title}</h3>
          <div className="Partner-Modal__Description" dangerouslySetInnerHTML={{ __html: desc }} />
          <Button
            icon={true}
            href={linkHref}
            text="Read More"
            type="text-link"
            size="small"
            target="_blank"
            rel="noopener noreferrer nofollow"
            theme="light"
          />
        </styled.PartnerModalWrapper>
      </div>
    </Modal>
  )
}

export default PartnersModal
